import $ from "jquery";

/**
 *  Read more toggle for use in expandable sections.
 * Implementations can be found in expandable-into-block
 */

 var showMoreContentBtn = $('.expandable-intro_read-more,.read-more-btn');
if(showMoreContentBtn.length)
{
    showMoreContentBtn = showMoreContentBtn[0];

    $(showMoreContentBtn).click(function () {
        if($('.expandable-intro_additional-content').length)
        {
            var additionalContent = $('.expandable-intro_additional-content');

            additionalContent.fadeToggle(0, function(){
                if ($(showMoreContentBtn).is(':contains("More")')) {
                    $(showMoreContentBtn).text("Read Less");
                    $(showMoreContentBtn).addClass("expandable-intro_read-less");
                    $(showMoreContentBtn).attr("aria-expanded", "true");
                    additionalContent.removeClass("content-is-hidden");
                } else {
                    $(showMoreContentBtn).text("Read More");
                    $(showMoreContentBtn).removeClass("expandable-intro_read-less");
                    $(showMoreContentBtn).attr("aria-expanded", "false");
                    additionalContent.addClass("content-is-hidden");
                }
            });
        } 
    });
}

const btnText = $(".read-more-btn");
if (btnText) {
    btnText.each( function(){
        var $this = $(this);

        this.addEventListener('click', function() {
            var moreText = $(this).siblings(".more-text");
    
            if (!$(this).hasClass('reading-more')) {
                $(this).html("Read less"); 
                moreText.css({"display": "block"});
                $(this).toggleClass('reading-more');
            } else {
                $(this).html("Read more"); 
                moreText.css({"display": "none"});
                $(this).toggleClass('reading-more');
            }
        });
    })
}
